import apiClient from '@/axios';

export const getTotalUsersWithProfiles = async () => {
  return apiClient.get('/admin/total-users');
};


export const getTotalPartners = async()=>{
    return apiClient.get('/admin/total-partners')
}


export const userInfo = async()=>{
    return apiClient.get('/admin/getCurrentInfo')
}

export const getRoles = async () => {
  return apiClient.get('/admin/get-roles');
};

export const createAdmin = async (data) => {
  try {
    const response = await apiClient.post('/admin/create', {
      email: data.email,
      password: data.password,
      role: data.role,
      full_name: data.full_name,
      last_name: data.last_name,
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 422) {
      const emailError = error.response.data.errors.email;
      if (emailError) {
        alert(emailError[0]);
      }
    } else {
      alert('Произошла ошибка. Попробуйте снова.');
    }
    throw error;
  }
};




export const getAdmins = async () => {
  return apiClient.get('/admin/get-admins-info');
};


export const fetchUserPermissions = async () => {
  const response = await apiClient.get('/admin/get_access');
  return response.data.permissions;
};